import BanIcon from "components/Icons/BanIcon";
import { useTripRequestAlertContext } from "./AlertContext";
import { ITripRequest } from "models/tripRequest";

interface IProps {
  tripRequest: ITripRequest;
}

export default function TripRequestAction({ tripRequest }: IProps) {
  const { showCancel } = useTripRequestAlertContext();

  const handleCancelClick = () => showCancel(tripRequest);

  return (
    <div className="flex items-center gap-x-3">
      {/* <Link
        to={RouteName.TRIP_DETAIL.replace(":id", tripRequest.id)}
        className="rounded-full hover:text-black"
      >
        <ViewIcon />
      </Link> */}
      {!["CANCELLED", "STARTED"].includes(tripRequest.status) && (
        <button onClick={handleCancelClick} className="rounded-ful">
          <BanIcon />
        </button>
      )}
    </div>
  );
}
